import { CarouselImage } from 'components/image-carousel';
import { BottomSheet } from 'react-spring-bottom-sheet';
import ImageObjectNotNavigate from 'screens/imageObject/imageObjectNotNavigate';

interface IModalCarouselProps {
  isOpen: boolean;
  images: CarouselImage[];
  onDismiss: (value: boolean) => void;
}

const ModalCarousel = ({ isOpen, images, onDismiss }: IModalCarouselProps) => {
  const handleClose = () => {
    onDismiss(false);
  };

  return (
    <BottomSheet
      open={isOpen}
      onDismiss={() => onDismiss(false)}
      snapPoints={({ minHeight, maxHeight }) => [minHeight, maxHeight]}
    >
      <div style={{ marginBottom: 20 }}>
        <ImageObjectNotNavigate images={images} onClose={handleClose} />
      </div>
    </BottomSheet>
  );
};
export default ModalCarousel;
